import { render, staticRenderFns } from "./endorsement-info.vue?vue&type=template&id=3dd0be7e&scoped=true&"
import script from "./endorsement-info.vue?vue&type=script&lang=js&"
export * from "./endorsement-info.vue?vue&type=script&lang=js&"
import style0 from "./endorsement-info.vue?vue&type=style&index=0&id=3dd0be7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd0be7e",
  null
  
)

export default component.exports